import React, { useState, useCallback, useEffect } from 'react'
import { View } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'

import { clearLoadDetails } from '../../redux/loadDetails/loadDetailsActions'
import LoadDetails from '../LoadDetails'
import Drawer from '../Drawer'
import { usePlatforms } from '../../hooks/usePlatforms'
import { loadDetailSelector } from '../../redux/loadDetails/loadDetailsSelector'
import { isTheSelectMenuClicked } from '../../tools/general'

const mapListId = {
  'all-loads': 'allLoadsListContainer',
  'my-loads': 'myLoadsListContainer',
  'my-offers': 'myOffersListContainer',
  'offers-history': 'offersHistoryListContainer',
  'assigned-orders': 'assignedOrdersListContainer',
  'ready-to-invoice': 'readyToInvoiceOrdersListContainer'
}

const LoadDetailsDrawer = () => {
  const dispatch = useDispatch()
  const { loadDetails } = useSelector(loadDetailSelector)
  const [isOpen, setIsOpen] = useState(false)
  const { isTablet } = usePlatforms()

  const handleSideMenu = useCallback((open) => {
    if (!open) {
      dispatch(clearLoadDetails())
    }
  }, [dispatch])

  const onClickOutside = useCallback((event) => {
    const list = document.querySelector(`[data-testid="${mapListId[loadDetails.module]}"]`)
    const details = document.querySelector('[data-testid="loadDetailsDrawerContainer"]')
    const dialog = document.querySelector('[data-testid="WebDialogContainer"]')
    if (list.contains(event.target) || details.contains(event.target) || (dialog && dialog.contains(event.target)) || isTheSelectMenuClicked(event)) {
      event.stopPropagation()
    } else {
      dispatch(clearLoadDetails())
    }
  }, [dispatch, loadDetails.module])

  useEffect(() => {
    if (loadDetails.module) {
      window.addEventListener('click', onClickOutside)
    }
    return () => {
      window.removeEventListener('click', onClickOutside)
    }
  }, [loadDetails.module, onClickOutside])

  useEffect(() => {
    setIsOpen(loadDetails.load && loadDetails.module)
  }, [loadDetails])

  return (
    isTablet && (
      <Drawer
        open={isOpen}
        onChange={handleSideMenu}
        width={400}
        onClickOutside={onClickOutside}
      >
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 10,
            zIndex: 10
          }}
          testID='loadDetailsDrawerContainer'
          accessibilityLabel='loadDetailsDrawerContainer'
        >
          <LoadDetails
            showMap
            load={loadDetails.load}
            onBid={() => {}}
            onBook={() => {}}
            containerStyle={{ height: '100%', width: '100%' }}
            module={loadDetails.module}
          />
        </View>
      </Drawer>)
  )
}

export default LoadDetailsDrawer
